'use strict';

/**
 * Extract billing address of corresponding PayPal payment account from paypal account option
 * @param {Object} $selectedPayPalPayment PayPal payment option
 * @returns {string} return string representation of extracted address
 */
function getBillingAddressAsString($selectedPayPalPayment) {
    var selectedBillingAddressStr = $selectedPayPalPayment.getAttribute('data-billing-address');
    var selectedBillingAddressObj;
    var billingAddressRepresentationString = '';

    if (selectedBillingAddressStr && selectedBillingAddressStr !== '') {
        selectedBillingAddressObj = JSON.parse(selectedBillingAddressStr);

        if (selectedBillingAddressObj && selectedBillingAddressStr !== '{}') {
            var address1 = selectedBillingAddressObj.line1 || selectedBillingAddressObj.address1 || '';
            var address2 = selectedBillingAddressObj.line2 || selectedBillingAddressObj.address2 || '';
            // Storefront customisation
            /*var firstName = selectedBillingAddressObj.firstName || '';
            var lastname = selectedBillingAddressObj.lastName || '';
            var city = selectedBillingAddressObj.city || '';
            var state = selectedBillingAddressObj.state || selectedBillingAddressObj.stateCode || '';
            var postalCode = decodeURIComponent(selectedBillingAddressObj.postalCode) || '';

            billingAddressRepresentationString = firstName + ' ' +
            lastname + ' ' +
            address1 + ' ' +
            city + ', ' +
            state + ' ' +
            postalCode;*/

            if (address1 || address2) {
                billingAddressRepresentationString = address1 + ' ' + address2;
            }
        }
    }

    return billingAddressRepresentationString;
}

/**
 * Display billing address of passed paypal payment option (of selected paypal payment option)
 * @param {Object} $selectedPayPalPayment Selected PayPal payment option
 */
function displaySelectedStoredBillingAddress($selectedPayPalPayment) {
    if ($selectedPayPalPayment) {
        var selectedOptionClassList = $selectedPayPalPayment.classList;

        if (selectedOptionClassList.contains('js-stored-paypal-account') || selectedOptionClassList.contains('js-session-paypal-account')) {
            var billingAddressAsString = getBillingAddressAsString($selectedPayPalPayment);
            var $storedPayPalAddressOption = $('#billingAddressSelector option[class="stored-paypal-address"]');
            var storedPayPalAddressOptionExists = $storedPayPalAddressOption.length;

            if (billingAddressAsString !== '') {
                if (storedPayPalAddressOptionExists) {
                    var address = $selectedPayPalPayment.getAttribute('data-billing-address');
                    if (address && address !== '') {
                        var addressObj = JSON.parse(address);
                
                        if (addressObj && addressObj !== '{}') {
                            $storedPayPalAddressOption.text(billingAddressAsString);
                            $storedPayPalAddressOption.attr('data-first-name', addressObj.firstName || '')
                            $storedPayPalAddressOption.attr('data-last-name', addressObj.lastName || '')
                            $storedPayPalAddressOption.attr('data-address1', addressObj.line1 || addressObj.address1 || '')
                            $storedPayPalAddressOption.attr('data-address2', addressObj.line2 || addressObj.address2 || '')
                            $storedPayPalAddressOption.attr('data-city', addressObj.city || '')
                            $storedPayPalAddressOption.attr('data-state-code', addressObj.state || addressObj.stateCode || '')
                            $storedPayPalAddressOption.attr('data-postal-code', decodeURIComponent(addressObj.postalCode) || '')
                            $storedPayPalAddressOption.attr('data-country-code', 'GB')
                            $storedPayPalAddressOption.attr('data-phone', )
                            $storedPayPalAddressOption.prop('selected', true);
                            $('.payment-form .addressSelector').trigger('change');
                        }
                    }
                } else {
                    $('#billingAddressSelector').append('<option class="stored-paypal-address" selected>' + billingAddressAsString + '</option>');
                }
            }
        }
    }
}

/**
 * Returns the matching address ID or UUID for a billing address
 * @returns {string} Matching address ID
 */
function getMatchingBillingAddressId() {
    var matchingBillingAddressId;

    $.ajax({
        url: document.querySelector('.js_braintree_getOrderInfoUrl').value + '?qwe=2344',
        type: 'get',
        async: false,
        dataType: 'json',
        success: function (data) {
            if (data.matchingBillingAddressId) {
                matchingBillingAddressId = data.matchingBillingAddressId;
            } else {
                matchingBillingAddressId = false;
            }
        },
        error: function () {
            window.location.reload();
        }
    });

    return matchingBillingAddressId;
}

/**
 * Set default billing address as selected
 */
function selectDefaultBillingAddressOption() {
    var billingAccountsSelector = '#billingAddressSelector';
    var $braintreePaypalAccountList = document.querySelector('#braintreePaypalAccountsList');
    var matchingBillingAddressId;

    if ($braintreePaypalAccountList) {
        matchingBillingAddressId = getMatchingBillingAddressId();

        if (matchingBillingAddressId && matchingBillingAddressId !== '') {
            $(`${billingAccountsSelector} option[value="${matchingBillingAddressId}"]`).prop('selected', true);
        } else {
            // Shows billing address of session account
            $(`${billingAccountsSelector} option[value="${'manual-entry'}"]`).prop('selected', true);
        }

        $(`${billingAccountsSelector} option[class="stored-paypal-address"]`).remove();
    }
}

module.exports = {
    displaySelectedStoredBillingAddress,
    selectDefaultBillingAddressOption
};
